<template>
<div>

<div class="container-fluid">
<!--<div class="row">-->


<div class="row">
<div class="col-md-4">

  
  
  
  <div class="card border-success">
  <div class="card-header text-white bg-primary">
    <h4> <i style="color:greenyellow" class="fas fa-cash-register mr-2" aria-hidden="true"></i>
      CONTROLLO CASSE
    <div class="row">
    <div class="col">  
    <button v-if="badge.count1" @click="badge.isOpen1 = true,badge.isOpen2=false" type="button" class="btn btn-warning float-right ml-3">
        Reset Saldo <span class="badge badge-light ml-2">
          {{badge.count1}}
        </span>
    </button> 
    <button v-if="badge.count2" @click="badge.isOpen1 = false,badge.isOpen2=true" type="button" class="btn btn-warning float-right ml-3">
        Fuori Listino <span class="badge badge-light ml-2">
          {{badge.count2}}
        </span>
    </button>
    </div>
    </div> 
    
   
      </h4>
      </div>

  <div  class="card-body"> 

  <div class="mb-4" v-if="badge.isOpen1">
    <H4 class="text-center">CLIENTI CON RESET SALDO</H4>
    <ul class="list-group">
    <li v-for="(item, index) in badge.customerList" :key='index'  class="list-group-item d-flex justify-content-between align-items-center">
      <strong>{{item.customer}}  </strong>
      <!--
      <span class="badge-warning badge-pill">

      {{item.balance_reset}}
      </span>
      -->

    </li>
    </ul>  
  </div>  
  <div class="mb-4" v-if="badge.isOpen2">
    <H4 class="text-center">SEDI CON VENDITE FUORI LISTINO</H4>
    <ul class="list-group">
    <li v-for="(item, index) in badge.storeList" :key='index'  class="list-group-item d-flex justify-content-between align-items-center">
      <strong>{{item.store}}  </strong>
      <span class="badge-info badge-pill">

        {{item.storeCount}}
      </span>
    </li>
    </ul>  
  </div>  

   <div v-if="pdf">
          <div class="row">       
          <iframe :src="pdf" width="400" height="400" style="margin-bottom:5px"></iframe>
          </div>
          <div class="row">
           <button @click="pdf=''" type="button" class="btn btn-primary"  aria-label="Close">
            CHIUDI
          </button>
          </div>
   </div>       
   <div  v-else>     
   
    <div v-if="type=='A'">

  <form class="form-inline_" name="payment" v-on:submit.prevent="getData()">

    <div class="form-group mb-2">
        <label for="staticEmail2" class="mr-2"><strong>DATA VENDITA</strong> </label>
        <input  v-focus type="date"  class="form-control mr-2" id="create_at"  v-model="create_at">
    </div>
    <button  class="btn btn-primary ml-2 ">
      <i  class="fas fa-binoculars mr-2" aria-hidden="true"></i>
      CERCA
       <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>
      
  </form>

 <alert-box style="margin-top:10px" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>



  <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table class="table table table-hover table-sm table-striped mb-0">
    <thead>
      <tr class="table-primary">
        <th >SEDE</th>
        <th >TIPO PAGAMENTO</th>
        <th class="text-right" >IMPORTO</th>
        
      </tr>
    </thead>
    <tbody>
      <span v-if="row_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
      <tr @dblclick="getDetail(item)" :class="item.typeId== null  ? 'pointer' : ''" :style="{backgroundColor: item.typeId == null ? '#FFFFE0':'white', color: item.typeId == null  ? 'blue' : 'black',fontSize: item.typeId == null ? '16px':'14px',fontWeight:item.typeId == null ? 'bold':'normal' }" v-for="(item, index) in items" :key="index">
        <td>{{item.store}}</td>  
        <td
       
        >
         
        {{item.typeId}}</td>
        <td class="text-right">{{fmt1(item.total)}}</td>
               
      </tr> 
    </tbody>
        <tfoot >
            <tr >
                <td class="text-left">TOTALE</td>
                <td class="text-left"></td>
                <td class="text-right">€ {{fmt1(total)}}</td>
            </tr>
      </tfoot> 
  </table>

  </div>

  <table class="table table-sm table-bordered table-striped ">
  <thead class="unionAll" >
    <tr class="table-light">
      
      <th scope="col">TIPO OPERAZIONE</th>
      <th class="text-right" scope="col">IMPORTO €</th>
      
    </tr>
  </thead>
  <tbody>
    <tr v-for="(item, index) in operations" :key="index">
      <td>{{item.typeId}}</td>
      <td class="text-right">{{fmt1(item.total)}}</td>
             
    </tr> 
  </tbody>
      
</table>




   </div>



<div v-else>


    <button  @click="type='A'"  class="btn btn-secondary  mt-2 mb-3">
    <i style="color:yellow"  class="fas fa-reply mr-2" aria-hidden="true"></i>
    CHIUDI
       
  </button>

 <div class="table-wrapper-scroll-y my-custom-scrollbar">



  <table class="table table-sm table-striped mb-0">
    <thead>
      <tr class="table-primary">
        <th >CASSA</th>
        
        <th >TIPO</th>
        
        
        <th class="text-right" >IMPORTO</th>
        <th class="text-right" >PAGAMENTI</th>
        <th class="text-right" >NON RISCOSSO</th>
        <th class="text-right" >COUPON INCASSATI</th>
        
      </tr>
    </thead>
    <tbody>
      <tr   
      
     :style="{ fontSize: !item.typeId  ? '16px':'14px',fontWeight: !item.typeId  ? 'bold':'normal' }"
      v-for="(item, index) in detail.items" :key="index">
        
        <td ><strong>{{item.deskId}}</strong></td>  
        <td>{{item.typeId}}</td>
        
        <td class="text-right"  
        
        
         >{{fmt1(item.total)}}</td>
        <td class="text-right">{{fmt1(item.total1)}}</td>
        <td class="text-right">{{fmt1(item.total2)}}</td>
        <td class="text-right">{{fmt1(item.total3)}}</td>
        
      </tr> 
    </tbody>
    <tfoot>
            <tr 
                      
               v-for="(item, index) in detail.foot" :key="index"
            >
                
                <td class="text-left">TOTALE {{detail.store}}</td>
                <td class="text-left"></td>
                <td class="text-right"
                
                
                >{{fmt1(item.total)}}</td>
                <td class="text-right">{{fmt1(item.total1)}}</td>
                <td class="text-right">{{fmt1(item.total2)}}</td>
                <td class="text-right">{{fmt1(item.total3)}}</td>
                
                

            </tr>
      </tfoot> 
  </table>

  </div>

</div>





  </div>


<!-- BODY CARD -->
</div>
</div>





</div>
</div>




</div>

</div>

</template>
<script>
import axios             from "axios";
import api               from '@/api';
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import cassa             from '@/components/common/Desk.vue';
import fmt               from '@/components/mixins/fmt.js'

export default {
  mixins:[fmt],
  components: {alertBox,cassa},
  data() {
    return {
    
      badge                 : {
          customerList      : [],
         
         
          count1            : 0,
          count2            : 0,
         
          isOpen1           : false,
          isOpen2           : false,
          storeList         : []
      },
      type                   : 'A',
      
      create_at              : new Date().toISOString().slice(0, 10),
      bt_spinner             : false,
      row_spinner            : false,
      
      msg                    : {
        title                : '',
        body                 : '',
        type                 : 0
      },
      items                  : [],
      detail                 : {},
      
      deskId                 : 1,
      pdf                    : '',
      total1                 : 0,
      total2                 : 0,
      total3                 : 0,
      total4                 : 0 ,
      operations             : []     
    
      
    };
  },
  computed :{
      
  
    ...mapGetters(['company']),
    

   total : function() {
   
      var total = 0
      this.items.forEach(item => {
        if(item.typeId==null)  
        { 
            total += item.total 
        }
      })

      return total
    }


  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        //el.focus();
      }
    }
  },
  mounted: function() {
    //this.getData()
  },
  created: function() {},
  methods: {
   async getDetail(item)
   {
      
      

      if(item.typeId)
      {
        return
      }
      this.detail = {}
      this.detail.store = item.store

      var sp    = {'sp':'spStoreDeskPayments'}
    
      var data  = {'storeId':item.storeId,'create_at':this.create_at}      
      var json  = Object.assign(data, sp)
      
      this.row_spinner = true
      await api.post(json).then(res => {
      if(res.status==200)
        {
          
          let items = []
          let detail = []
          

          res.data.recordsets.forEach(item=>
          {
          item.forEach(row=>
          {
              
              if(row.deskId > -1)
              {
                
                items.push(row)
              }
              else
              {
          
                detail.push(row)
              }
          }
          )

          })

          
          
          this.detail.items = items

          this.detail.foot = detail
                    
          this.type = 'B'

          /*
          this.total1 = res.data.recordsets[1][0]['total1']
          this.total2 = res.data.recordsets[2][0]['total2']
          this.total3 = res.data.recordsets[3][0]['total3']
          */

          if(this.detail.items.length==0)
          {
           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = 'DATI INESISTENTI.'
            this.msg.type  = 1
          }         
        }
        else if(res.status==500)
        {
         
     
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res.data
          this.msg.type  = 1
        } 
        else
        {
          
          
     
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res
          this.msg.type  = 1                  

        } 
    }).catch(err => 
    {
      
     
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = err.message
      this.msg.type  = 1       
       
    }).finally(() => {
      this.row_spinner = false
    });






 


   },
   createPDF()
      {
        
        this.bt_spinner = true
        //this.msg      = ''
        var url       = process.env.VUE_APP_ROOT_API + "api/document/create/payments" 
        var data      = {}
        
        data.items    = []
        this.items.forEach(item=>{
          data.items.push(item)
        })
        data.items.push({'typeId':'TOTALE','total':this.total})
        //data.items.push({'typeId':'TOTALE','total' : '€ ' +  this.total})
        
        
        //var document = {type:this.shipping.typeId==1 ? 'Fattura' : 'DDT',data:this.shippingDate,number : this.shipping.number,supplier:this.supplier.List[0].supplier }
        //var json  = Object.assign(data,document);
        var json =  data

        //console.log()
        //return

        axios({
        url     : url,
        method  : "post",
        data    : json,
        
      })
        .then(res => {
          this.pdf   =  process.env.VUE_APP_ROOT_API + 'api/pdf/' +  res.data

        })
        .catch(err => {})
        .finally(() => {
          this.bt_spinner = false
           
        });
      },
    
    async getData() {
      
      this.badge.isOpen1 = false
      this.badge.isOpen2 = false
      this.badge.customerList = []
      this.badge.count1 = 0
      this.badge.count2 = 0
      this.badge.storeList = []

      this.items = []
      this.total1 = 0
      this.total2 = 0
      this.total3 = 0
     
      this.msg.title = ''

      if(!this.create_at)
      {
        
        this.msg.title = 'ATTENZIONE '
        this.msg.body  = 'Data di vendita non valida.'
        this.msg.type  = 1
        return
      }
      
      var sp    = {'sp':'spCompanyPaymentsUnionAll'}
      
      

      var data  = {'companyId':this.company.Id,'create_at':this.create_at}      
      var json  = Object.assign(data, sp)
      
      this.bt_spinner = true
      await api.post(json).then(res => {
      if(res.status==200)
        {


          this.items = res.data.recordsets[0].filter(item => item.store != null)
          this.operations = res.data.recordsets[1]
          /*
          this.total1 = res.data.recordsets[1][0]['total1']
          this.total2 = res.data.recordsets[2][0]['total2']
          this.total3 = res.data.recordsets[3][0]['total3']
          
          this.total4 = res.data.recordsets[7][0]['total4']
          */
          //this.badge.data = res.data.recordsets[4]
          
          
          if(res.data.recordsets[2].length)
          {
            this.badge.count1        = res.data.recordsets[2][0].badge_count
            this.badge.customerList  = res.data.recordsets[2]
          }

          if(res.data.recordsets[3].length)
          {
            this.badge.count2 = res.data.recordsets[3][0].badge_count
            this.badge.storeList = res.data.recordsets[4]
          }
          
         


          if(this.items.length==0)
          {
           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = 'DATI INESISTENTI.'
            this.msg.type  = 1
          }         
        }
        else if(res.status==500)
        {
         
     
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res.data
          this.msg.type  = 1
        } 
        else
        {
          
          
     
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = res
          this.msg.type  = 1                  

        } 
    }).catch(err => 
    {
      
     
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = err.message
      this.msg.type  = 1       
       
    }).finally(() => {
      this.bt_spinner = false
    });







    }
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 400px;
overflow: auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}


h4,p {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 14px;
    color        : rgb(16, 16, 15) !important;
    background   : #a9cbe2;
    
  
    

    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 18px;
    background   : green;
    color        : white;  
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 40px;
    font-weight  : bold;


 }
 .table .unionAll tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : white;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
 .card-header
{
  height: 45px;
}
</style>